import axios from 'axios'
import { ChangeEvent, FormEvent, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import appConfig from '../../config'
import routes, { externalRoutes } from '../../routes'
import { loggedIn, loggedOut, loggingIn } from '../../slices/authSlice'
import { LoginPg } from './styled'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleEmailInput = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const handlePasswordInput = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  const handleLogin = (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)
    if (email.length && password.length) {
      dispatch(loggingIn())

      axios
        .post(`${appConfig.API_URL}/login`, {
          email: email,
          password: password,
        })
        .then(({ status, data }) => {
          if (status === 200) {
            localStorage.setItem('jwt_token', data.token)
            dispatch(loggedIn(data.user))
            navigate(routes.onDemandSessions)
            toast(`Welcome ${data.user.fullName}`)
          } else {
            dispatch(loggedOut())
          }
        })
        .catch((error) => {
          console.log('ERROR', error)
          dispatch(loggedOut())
          toast(error.response.data.message)
          setLoading(false)
        })
    } else {
      toast('Email and password must not be blank')
      setLoading(false)
    }
  }

  return (
    <LoginPg>
      <div className="loginBox">
        <h2 className="text-danger">Welcome to LESA 2023</h2>
        <form className="w-75" onSubmit={handleLogin}>
          <div className="pt-2">
            <label htmlFor="email">Email*</label>
          </div>
          <div className="py-2">
            <input
              className="w-100"
              type="email"
              onChange={handleEmailInput}
              placeholder="Enter Your Email"
              value={email}
            />
          </div>
          <div className="pt-2">
            <label htmlFor="password">Password</label>
          </div>
          <div className="py-2">
            <input
              className="w-100"
              type="password"
              onChange={handlePasswordInput}
              placeholder="Enter Your Password"
              value={password}
            />
          </div>
          <div className="py-3">
            <button disabled={loading} className="btn btn-danger login-btn">
              {loading ? 'Logging In...' : 'Login'}
            </button>
          </div>
          <div className="bottom-text">
            <p>
              Forgot password?{' '}
              <a className="text-danger" href={externalRoutes.resetPassword}>
                Reset here
              </a>
            </p>
          </div>
        </form>
      </div>
    </LoginPg>
  )
}

export default Login
